import { SuministroInformacionComponent } from "../components/suministro-de-informacion/suministro-informacion/suministro-informacion.component";

export const COMPONENTS = [
	{
    name: 'Solicitud de suministro de información',
    value: 'SuministroInformacion',
    component: SuministroInformacionComponent,
    caso: 'Suministro de información'
  },
]